import React, { Component } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import Styles from './CheckboxGroup.styles';

class CheckboxGroup extends Component {
  getCheckboxItem = ({
    label,
    value,
    name,
    onChange,
    onBlur,
    onFocus,
    inputValue,
  }) => {
    const handleChange = (event) => {
      const arr = [...inputValue];
      if (event.target.checked) {
        arr.push(value);
      } else {
        arr.splice(arr.indexOf(value), 1);
      }
      onBlur(arr);
      return onChange(arr);
    };
    const checked = inputValue.includes(value);
    const id = `${name}[${value}]`;

    return (
      <div key={id}>
        <input
          checked={checked}
          id={id}
          name={id}
          onChange={handleChange}
          onFocus={onFocus}
          type="checkbox"
          value={value}
        />
        <label
          className={Styles.label}
          htmlFor={id}
        >
          {label}
        </label>
      </div>
    );
  }

  field = ({ input, meta, options }) => {
    const { name, onChange, onBlur, onFocus } = input;
    const { touched, error } = meta;
    const inputValue = input.value;

    const checkboxes = options.map((option) => this.getCheckboxItem({
      ...option,
      name,
      onChange,
      onBlur,
      onFocus,
      inputValue,
    }));

    return (
      <div>
        <div>{checkboxes}</div>
        {touched && error && <p className="error">{error}</p>}
      </div>
    );
  }

  render() {
    return (
      <Field
        {...this.props}
        component={this.field}
        type="checkbox"
      />
    );
  }
}

CheckboxGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default CheckboxGroup;
